import { render } from "./RobotBuilder.vue?vue&type=template&id=8827ecba"
import script from "./RobotBuilder.vue?vue&type=script&lang=js"
export * from "./RobotBuilder.vue?vue&type=script&lang=js"

import "./RobotBuilder.vue?vue&type=style&index=0&id=8827ecba&lang=css"

import exportComponent from "C:\\Users\\MichaelGranbäck\\vue\\clones\\build-a-bot\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__